export default __webpack_public_path__ + "static/media/syn_survey.68df83e3.jpg";